import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

class SrSimpleDropdownWithSearchBar extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        title: PropTypes.node.isRequired,
        isActive: PropTypes.bool,
      }),
    ).isRequired,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    multiple: PropTypes.bool,
    footer: PropTypes.node,
  };

  static defaultProps = {
    multiple: false,
    placeholder: 'Search',
  };

  constructor(...args) {
    super(...args);
    this.state = {
      searchTerm: '',
    };
  }

  _handleCheckboxToggle = (clickedOptionId) => {
    this.props.onChange(clickedOptionId);
  };

  _handleSearchChange = (e) => {
    const updatedSearchTerm = e.target.value;
    this.setState({
      searchTerm: updatedSearchTerm,
    });
  };

  _isSubstring = ({ array, subarray }) => {
    const lowercaseArray = array.toLowerCase() || '';
    const lowercaseSubarray = subarray.toLowerCase() || '';
    return lowercaseArray.includes(lowercaseSubarray);
  };

  _getOptionComponent = (option) => {
    const { searchTerm } = this.state;

    const { multiple } = this.props;

    const isSubstring = this._isSubstring({
      array: option.title,
      subarray: searchTerm,
    });

    const optionComponent = (
      <span
        key={`${option.id}`}
        className={classnames('option', { active: option.isActive, multiple: multiple })}
        onClick={() => this._handleCheckboxToggle(option.id)}
      >
        {option.title}
      </span>
    );

    if (!searchTerm || isSubstring) {
      return optionComponent;
    }
    return null;
  };

  render() {
    const { title, options, footer, placeholder } = this.props;

    const { searchTerm } = this.state;

    return (
      <div className="SrSimpleDropdownWithSearchBar">
        <span className="label">{title}</span>
        <div className="dropdownContainer">
          <input
            className="searchbar"
            onChange={this._handleSearchChange}
            value={searchTerm}
            placeholder={placeholder}
          />
          {options.map((option) => this._getOptionComponent(option))}
          {footer}
        </div>
      </div>
    );
  }
}

SrSimpleDropdownWithSearchBar.displayName = 'SrSimpleDropdownWithSearchBar';

export default SrSimpleDropdownWithSearchBar;
